import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import trackingServices from "../../../Services/trackingService";
import SimpleReactValidator from "simple-react-validator";

const TRACKING_STATUSES = [
  {
    value: "BOOKING_CONFIRMED",
    label: "BOOKING CONFIRMED",
    stage: "Pick Up in progress",
    dateLabel: "Expected Pickup Date",
  },
  {
    value: "SHIPMENT_AT_WAREHOUSE",
    label: "SHIPMENT AT WAREHOUSE",
    stage: "Export formalities in progress",
    dateLabel: "Expected Departure Date",
  },
  {
    value: "DEPARTED",
    label: "DEPARTED",
    stage: "In transit",
    dateLabel: "Expected Arrival Date",
  },
  {
    value: "ARRIVED",
    label: "ARRIVED",
    stage: "Import formalities in progress",
    dateLabel: "Expected Delivery Date",
  },
  {
    value: "DELIVERED",
    label: "DELIVERED",
    stage: "",
    dateLabel: "",
  },
];

const nextStageStatuses = ["BOOKING_CONFIRMED", "SHIPMENT_AT_WAREHOUSE", "DEPARTED"];

export const EditTracking = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [trackData, setTrackData] = useState({});
  const [shipmentStatus, setShipmentStatus] = useState("");
  const [tDate, setTDate] = useState(null);
  const [expactDate, setExpactDate] = useState(null);
  const [nextexpactDate, setnextExpactDate] = useState(null);
  const [remarkval, setRemarkval] = useState("");
  const [, forceUpdate] = useState("");
  const [jobstatus, setJobStatus] = useState("");

  const simpleValidator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const history = useHistory();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const jobId = params.get("id");
  useEffect(() => {
    let data = { job_token: jobId };
    trackingServices.getTrackingDetail(data).then((result) => {
      setJobStatus(result.data.job_status);
      if (result.status === true) {
        setTrackData(result.data);
        if (
          result.data.job_status &&
          result.data.job_status === "BOOKING_REQUESTED"
        ) {
          setShipmentStatus("");
        } else {
          setShipmentStatus(result.data.job_status);
        }

        if (Array.isArray(result.data.job_status_values)) {
          let shipStatus = result.data.job_status_values.filter(
            (item) => item.job_status === result.data.job_status
          );
          if (Array.isArray(shipStatus) && shipStatus.length > 0) {
            setTDate(shipStatus[0].tracking_date);
          }
        }

        setExpactDate(result.data.expacted_date);
        setnextExpactDate(result.data.next_stage_expected_date);
        setRemarkval(result.data.remarks);

        setIsDataLoaded(true);
      }
    });
  }, []);

  const editTrack = () => {
    const formValid = simpleValidator.current.allValid();
    // let isValid = simpleValidator.current.check(
    //   nextexpactDate,
    //   "required",
    //   "next_stage_expected_date",
    // );
    
    let allValid = simpleValidator.current.fieldValid("status") && 
    simpleValidator.current.fieldValid("trackingDate")
    && simpleValidator.current.fieldValid("expactedDate")   
    

    if (nextStageStatuses.includes(shipmentStatus)) {
          allValid = allValid && simpleValidator.current.fieldValid("next_stage_expected_date")
        }

    if (allValid ) {
      let data = {
        job_token: trackData.job_token,
        job_status: shipmentStatus,
      };
      if (tDate) {
        data.tracking_date = tDate;
      }
      if (expactDate) {
        data.expacted_date = expactDate;
      }
      if (shipmentStatus) {
        data.job_status = shipmentStatus;
      }
      if (nextStageStatuses.includes(shipmentStatus)) {
        data.next_stage_expected_date = nextexpactDate;
      }
      if (remarkval) {
        data.remarks = remarkval;
      }
      trackingServices.updateTracking(data).then((result) => {
        if (result.status === true) {
          toast.success(result.message);
          history.push("/tracking-list");
        }
      });
    } else {
      simpleValidator.current.showMessages();
    }
  };

  const updateStatus = (value) => {
    setShipmentStatus(value);
    const copyData = {...trackData}
    copyData.job_status= value
    if (!nextStageStatuses.includes(value)) {
      setnextExpactDate(new Date().toISOString().split("T")[0])
      copyData.next_stage_expected_date= new Date().toISOString().split("T")[0];
    }
    setTrackData(copyData);
  };

  const trackingDate = (event) => {
    setTDate(event.target.value);
  };

  const nextstageExpecteddate = (event) => {
    setnextExpactDate(event.target.value);
  };

  const expactedDate = (event) => {
    setExpactDate(event.target.value);
  };

  useEffect(() => {
    if (nextStageStatuses.includes(shipmentStatus)) {
      setnextExpactDate("");
      setTrackData({ ...trackData, next_stage_expected_date: "" });
    }
  }, [shipmentStatus]);

  return (
    isDataLoaded && (
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <form className="control-form">
                <div className="row">
                  <div className="mb-3 col-6">
                    <label className="form-label">Job No.</label>
                    <input
                      disabled
                      className="form-control"
                      placeholder="Enter Job No"
                      value={trackData.job_token}
                    />
                  </div>
                  <div className="mb-3 col-6">
                    <label className="form-label">Customer Name</label>
                    <input
                      disabled
                      className="form-control"
                      placeholder="Enter Customer Name"
                      value={trackData.user_full_name}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3 col-4">
                    <label className="form-label">Shipment Status</label>

                    <select
                      name="status"
                      className="form-control"
                      onChange={(e) => updateStatus(e.target.value)}
                      value={trackData?.job_status || ""}
                    >
                      <option value="">Select Status</option>
                      {TRACKING_STATUSES.map((item, index, arr) => {
                        const currentIndex = arr.findIndex(
                          (opt) => opt.value === jobstatus
                        );

                        return (
                          <option
                            key={item.value}
                            value={item.value}
                            disabled={currentIndex > -1 && index < currentIndex}
                          >
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                    {TRACKING_STATUSES.find((item) => item.value === shipmentStatus)?.stage && (
                      <div className="mt-2" style={{ fontSize: "0.85rem", fontWeight: 600, color: "#475569" }}>
                        Stage: {TRACKING_STATUSES.find((item) => item.value === shipmentStatus).stage}
                      </div>
                    )}

                    {simpleValidator.current.message(
                      "status",
                      shipmentStatus,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </div>

                  {nextStageStatuses.includes(shipmentStatus) && (
                    <div className="mb-3 col-4">
                      <label className="form-label">
                        {TRACKING_STATUSES.find((item) => item.value === shipmentStatus)?.dateLabel}
                      </label>
                      <input
                        type="date"
                        name="next_stage_expected_date"
                        className="form-control"
                        value={nextexpactDate}
                        onChange={(e) => nextstageExpecteddate(e)}
                        min={new Date()}
                      />
                        {/* [
                        "BOOKING_CONFIRMED",
                        "SHIPMENT_AT_WAREHOUSE",
                        trackData?.origin_country !==
                          trackData?.destination_country && "DEPARTED",
                      ].includes(shipmentStatus) && */}
                      {
                        simpleValidator.current.message(
                          "next_stage_expected_date",
                          nextexpactDate,
                          "required",
                          {
                            className: "text-danger",
                          }
                        )}
                    </div>
                  )}

                  <div className="mb-3 col-4">
                    <label className="form-label">Status Date</label>
                    <input
                      type="date"
                      name="trackingDate"
                      className="form-control"
                      value={tDate}
                      onChange={(e) => trackingDate(e)}
                      min={new Date()}
                    />
                    {simpleValidator.current.message(
                      "trackingDate",
                      tDate,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </div>

                  <div className="mb-3 col-4">
                    <label className="form-label">Expected Delivery Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="expactedDate"
                      value={expactDate}
                      onChange={(e) => expactedDate(e)}
                    />
                    {simpleValidator.current.message(
                      "expactedDate",
                      expactDate,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </div>

                  <div className="mb-3 col-4">
                    <label className="form-label">Remarks</label>
                    <input
                      className="form-control"
                      placeholder="Enter Remarks"
                      value={remarkval}
                      onChange={(e) => setRemarkval(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mt-3 d-flex justify-content-between">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => editTrack()}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
